Object.defineProperty(exports, '__esModule', { value: true });

var react = require('react');

var PortalContext = react.createContext(function () { return null; });

exports.PortalContext = PortalContext;
